export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'نوع النموذج بنفس الاسم موجود بالفعل في هذه المؤسسة'
    }
  }
}
